import React from 'react';
import PropTypes from 'prop-types';
import PinInputModal from 'components/admin/Pin/PinInputModal';
import { usePinValidation } from 'hooks/usePinValidation';
import { toast } from 'react-toastify';

/**
 * HOC component that provides PIN protection for actions
 * @param {object} props - Component props
 * @returns {JSX.Element} - The wrapped component with PIN protection
 */
const PinProtectedAction = ({ clubId, children, onPinError = null }) => {
  const {
    showPinInput,
    pinAction,
    pinValidationLoading,
    pinDescription, // Now available from the hook
    requestPinValidation,
    handlePinConfirmed,
    cancelPinInput,
  } = usePinValidation(clubId);

  const handlePinConfirmedWithError = async (pinData) => {
    try {
      await handlePinConfirmed(pinData);
    } catch (error) {
      const errorMessage = error.message || 'PIN validation failed';
      if (onPinError) {
        onPinError(errorMessage);
      } else {
        toast.error(errorMessage);
      }
    }
  };

  return (
    <>
      {children({ requestPinValidation, pinAction, pinValidationLoading })}

      <PinInputModal
        clubId={clubId}
        showPopup={showPinInput}
        closePopup={cancelPinInput}
        confirmPin={handlePinConfirmedWithError}
        description={pinDescription} // Pass description to modal
      />
    </>
  );
};

PinProtectedAction.propTypes = {
  clubId: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  onPinError: PropTypes.func,
};

export default PinProtectedAction;
